import gql from "graphql-tag";

export const updateProviderAlertsByTokenMutationFragment = gql`
	fragment updateProviderAlertsByTokenMutationFragment on UpdateManyProviderAlertPayload {
		error {
			message
		}
	}
`;
